export const pageContent = {
    // FACILITIES
    "fab-lab": {
        title: "FAB Lab",
        category: "Facilities",
        image: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&q=80&w=1200",
        content: "College of Engineering, Chengannur is one of the 18 engineering colleges equipped with Mini Fablab.CEC Mini Fablab is funded by a joint venture of Kerala Technical University and Startup Mission under the government of Kerala. The Fablab concepts originally conceived at  MIT by Neil Gershenfeld and partially financed by the NSF.Mini Fablab is a platform offering digital fabrication technology solutions as a bridge between idea and industry, creativity and production. Mini Fablab provides an opportunity for making rapid prototypes of digitally controlled hardware.Students of any discipline who wish to move more quickly from an idea or concept to a physical object or prototype can avail Fablab. Mini Fablab is a part of a worldwide network of 100, stretching from Costa Rica to the Netherlands.CEC Mini Fablab is equipped with numerically controlled modern operating by CAD/CAM tools.\n\nFor more visit: http://citcec.in",
        gallery: [
            "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&q=80&w=800",
            "https://images.unsplash.com/photo-1581092334651-ddf26d9a09d0?auto=format&fit=crop&q=80&w=800",
            "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=800"
        ]
    },
    "library": {
        title: "Central Library",
        category: "Facilities",
        image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&q=80&w=1200",
        tabs: {
            "Rules": `The College Library has a wide collection of latest books, periodicals, and CDs.

This collection is expanded and updated each year. The open access catalog system (OPAC) provides reading and reference facilities for both faculty and students. Online and offline information is offered and new resources are added to provide a holistic and comprehensive service. The institution maintains a general library, an IEEE library (restricted for IEEE members) and three department libraries.

Library Working Hours:
• The lending section is functioning between 8.30 am and 5.00 pm.
• The reference section is functioning from 8.30 am to 6.00 pm. It may be extended till 8.00 pm on genuine request.

Membership:
• For the staff members, books will be issued for a period of 30 days at a time.
• Student members can avail 5 books for a period of 14 days and can be renewed twice.

Library Rules:
1. Entry to the library is restricted to the bona fide members on production of valid Identity card/ Library card/ Visitors pass at the security checkpoint.
2. The users are not allowed to bring the books issued to them inside the library unless they intend to return them.
3. Strict silence should be maintained in the library.
4. General books are issued to all eligible members as per their entitlement.
5. Readers should check the book thoroughly for missing pages, chapters, pictures etc. while borrowing the book.
6. No book in damaged condition will be accepted from the reader. Mutilated or spoiled books will have to be replaced by the borrower.
7. Issued books cannot be returned on the same day.
8. Readers can reserve the books either online or at the circulation counter.
9. Loss of books should be reported immediately. Late fees if any will be charged till the loss of book is reported. If the original book is returned after reporting as lost, the fine will be calculated until the date of its return.
10. Rules of the replacement of lost books can be ascertained from the circulation section.
11. Books in TEQIP book bank section will not be issued overnight.
12. The books which are already issued can be claimed/ reserved online or at the issue counter. One user can put up to 3 claims that will remain valid for 7 days from the date of return.
13. Reserved books will not be renewed further.
14. The borrowing facility will be withdrawn in case of misuse of the library facility.
15. Overdue charges will be collected for late return @ Rs.2/- for 3 days after the due date, @ Rs.5/- for the next 5 days, @ Rs.10/- for the next 5 days subject to a maximum of 27 days as a whole as per prevailing rules.
16. Reference books and journals can be borrowed only overnight and it should be returned before 11.00 am next day and a fine will be collected @ Rs.5/- for the first 2 days and Rs.10/- for the next 2 days subject to a maximum of 5 days as a whole.
17. If the books are not returned within the prescribed periods mentioned above, the borrowing facility of the defaulters will be disabled.`,
            "Book Bank": `TEQIP Book Bank

The objective of the scheme is to provide textbooks to students. Books will be issued on loan to deserving students each semester.

Book Bank Scheme for SC/ST Students

There is a collection of over 600 books purchased under the Book Bank scheme of the SC/ST department of Govt. of Kerala. Under the scheme, students belonging to SC/ST category are entitled to avail maximum of five books which can be retained for a full semester.

Alumni Book Bank

The Alumni Book Bank contains over 150 books which are made available to the financially backward students.`,
            "E-Resources": `The following E-journal packages are available in the digital library:
• IEEE/ASPP
• SPRINGER
• Mc GRAW HILL
• ELSEVIER
• JGATE
• ASTM

The library has IP enabled access to the above online journals.

Developing Library Network (DELNET):
Can be used for referring to bibliographic information and availing online documents.

National Programme on Technology Enhanced Learning (NPTEL):
NPTEL e-learning materials are available in the library. The 129 Web courses and 110 Video courses which are subscribed by the institution are available in the intranet (http://cecnptel).`,
            "Journals": `Print & Online Journals:
The library subscribes to standard national and international print journals, technical magazines, and general periodicals. Select a category below to view our subscription list:

[Dropdown] NATIONAL JOURNALS
• Pramana Journal Of Physics
• Proceedings Mathematical Science
• Journal Of Earth System Science
• Journal Of Astrophysics& Astronomy
• Journal of Chemical Science
• Bulletin Of Material Science
• Sadhana( Eng.Science)
• Journal of Bio-Science
• Journal Of Genetics
• Resonance-Journal Of Science
• Current Science
• Journal Of Scientific& Industrial Research
• Journal Of Indian Management
• Management Research
• Operations Management
• Soft Skills
• Information Technology
• Computer Science
• Electrical and Electronic Engg.
• Mechanical Engineering
• Telecommunications
• Energy N Management
• Journal Of Education& Technology
• Indian Review OF Electric Power Application
• Indian Journal Of Measurement& Instrumentation Engineering
• Indian Journal Of Advanced Material Science
• Indian Journal Of Materials Physics
• Indian Journal Of Advances In Electrical Engg.
• Indian Journal Of Electronic Engg.Networks& Devices
• Indian Journal Of Electrical Engg. Computer Engg
• Indian Journal Of Industrial Electronics& applications
• Indian Journal Of Electronics Research And Engg
• Indian Journal Of Advances In Commn. Engg.
• Indian Journal Of Electronic Circuits, Devices& Systems
• Indian Journal Of System Engg.& Electronics
• Current Development In Electrical Engg.
• Indian Journal Of Wireless& Mobile Commn.
• Indian Journal Of Mobile Commn &Networks
• Indian Journal Of Electrical Engg. & Modern Technology
• Indian Journal Of Electronics Engg.& Commn. Engg.
• Indian Journal Of Advance Electronic Engg.
• Indian Journal Of Computer Graphics&Techniques
• Indian Journal Of Image Processing& Technique
• Indian Journal Of Neural Networks& Techniques
• Indian Journal Of secure internet& computer security
• Indian Journal Of soft computing Processing& Technique
• Indian Journal Of Electronics& Micro Circuits
• Indian Journal Of Electronic Engg.& Commn. Research
• Indian Journal Of Embedded System In Engg.Research
• Indian Journal Of soft Computing
• Indian Journal Of VLSI& circuit design
• Indian Journal Of Advanced Computer And VLSI design

[Dropdown] TECHNICAL MAGAZINES
• Electronics For You
• Linux For You
• Developer IQ
• Digit
• Express Computer
• Industrial Automation
• PC Quest

[Dropdown] INTERNATIONAL JOURNALS (print form)
• Int.jnl of Bio Infomatics& Soft computing
• Int.jnl of Electrical Engg& Embedded Systems
• Int.jnl of Micro& Nano Electrical System
• Int.jnl of Cybernetics& Systems
• Sajosps

[Dropdown] GENERAL PERIODICALS
• Autocar
• Bhashaposhini
• Competition Success Review
• Designer
• Dhanam
• Employment News
• Fast Track
• Forbes India
• Frontline
• Grihalekshmi
• India Today
• India Today (Malayalam)
• Infokairali
• Inside outside
• Kala Kaumudi
• Karshakasree
• Manorama Arogyam
• Mathrubhoomi Weekly
• Mathrubhoomi Arogya Masika
• Mathrubhoomi Sports Masika
• Outlook
• Overdrive
• PSC Bulletin
• Samakalika Malayalam
• Sambadyam
• Sports Star
• Star & Style
• The Week
• Thozhilvartha
• Thozhilveedhi
• TopGear
• Vanitha
• Vanitha Veedu
• Women’s Era
• Yathra

Reference and Overnight Lending:
• Reference books and journals can be borrowed only overnight.
• They must be returned before 11.00 AM the next day.
• Overdue charges will be collected for late returns as per library rules.`
        }
    },
    "college-bus": {
        title: "Transportation Facility",
        category: "Facilities",
        image: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&q=80&w=1200",
        content: `The college is providing efficient transportation facilities for the staffs and students to the nearby places/towns.

The college bus routes are as follows:

• Route 1: From Changanacherry starting at 8.10 AM via Thiruvalla.
• Route 2: From Haripad starting at 7.50 AM via Mavelikkara.`
    },
    "hostel": {
        title: "Hostel",
        category: "Facilities",
        image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?auto=format&fit=crop&q=80&w=1200",
        content: `There are 6 hostels associated with the college (2 for Boys and 4 for Girls).

**BOYS HOSTEL DETAILS:**

**1. Crown Boys Hostel (First Years Only)**
Location: Moolappadavu, Police station Road, Near Citizen Club
Warden: Suresh M
Contact: 9846218001
Capacity: 100 students

**2. Mens Hostel (Melepandiyil, Althara jn.)**
Warden: Suresh M
Contact: 9846218001

**LADIES HOSTEL DETAILS:**

**Chief Warden:** Premakumari K.R (Contact: 9495113734)

**1. Nandanam Ladies Hostel**
Strength: 60
Warden: Deepa G.R (Contact: 9447084806)
Location: Near to the College (500 mtr)

**2. Gokulam Ladies Hostel**
Strength: 62
Warden: Girija M.G (Contact: 9847889981)
Location: Near to the College (500 mtr)

**3. Vrindavanam Ladies Hostel**
Strength: 60
Warden: Sobhiraj N (Contact: 9497104756)
Location: Distance from college 4km

**4. Madhavam Ladies Hostel**
Strength: 90
Warden: Haseena P.Y (Contact: 9496292310)
Location: Distance from college 4km

**Note: College bus is available for Girls Hostel.**

All the hostels have a warden to supervise and to address any grievances.`
    },

    // COMMITTEES
    "parents-teachers": {
        title: "Parents Teachers Association (PTA)",
        category: "Committees",
        content: `The Parents Teachers Association (PTA) of College of Engineering Chengannur fosters a collaborative environment between educators and families to support the academic, professional, and personal growth of our students.

Name of Executive members (Parents):

• Sri. Thomas M David (Vice President) — Mobile: 9446666139 | Student: Deepa Hannah Thomas (S8 CS)
• Dr. Jayalekshmi P A (Joint Secretary) — Mobile: 9447009355 | Student: R. Devanarayanan (S6 CS)
• Sri. Santhosh Ampadi (Member) — Mobile: 9446294472 | Student: Meenakshi S (S4 CL)
• Smt. Sunitha Sajeev (Member) — Mobile: 9947968941 | Student: Sreeraman S Nair (S6 EEE)
• Sri. Suresh M (Member) — Mobile: 9846218001 | Student: Sidharth Suresh Madhav (S4 CS)
• Sri. Unnikrishnan K G (Member) — Mobile: 7025498009 | Student: Arjun Krishna (S2 EC)

Name of Executive Committee Members (Teachers):

• Dr. Hari V S (Principal) — Mobile: 8547005032 | Position: President
• Dr. T E Ayoob Khan (Professor, Dept. of Electronics Engg.) — Mobile: 9447556722 | Position: Secretary
• Dr. Lekha R Nair (Professor, Dept. of Electronics Engg.) — Mobile: 9496570592 | Position: Treasurer
• Dr. Shanavaz K T (Dean Academic) — Mobile: 9496108494 | Position: Member
• Dr. C V Anilumar (HOD Electronics Engg) — Mobile: 9446108491 | Position: Member
• Dr. Ashok Kumar T V (HOD General Engg.) — Mobile: 9447709779 | Position: Member
• Dr. Renu George (HOD Computer Engg.) — Mobile: 9747401150 | Position: Member
• Dr. Raju M (HOD Electrical Engg.) — Mobile: 9747405790 | Position: Member
• Smt. Moni P John (HOD Basic Science & Language) — Mobile: 9446538651 | Position: Member`
    },
    "right-to-info": {
        title: "Right to Information",
        category: "Committees",
        content: `In compliance with the Right to Information (RTI) Act, College of Engineering Chengannur maintains absolute transparency in all its academic, administrative, and financial activities. The designated officers under the RTI Act are listed below:

Public Information Officer:
• Smt. Asha K Pillai (Senior Superintendent)
• Email: ashakpillai2016@gmail.com | Mobile: 94473731

Assistant Public Information Officer:
• Sri. Anoop Raj T V (Junior Superintendent)
• Email: anoopraj@ceconline.edu | Mobile: 7561866090

Appellate Authority:
• Dr. Hari V S (Principal, College of Engineering Chengannur)
• Email: principal@ceconline.edu | Mobile: 8547005032`
    },
    "women-cell": {
        title: "Women Cell",
        category: "Committees",
        content: "The Women Cell focuses on the empowerment, safety, and professional development of female students and staff members in the technical field. Lorem ipsum dolor sit amet."
    },
    "grievance": {
        title: "Grievance Redressal Cell",
        category: "Committees",
        content: "A dedicated mechanism for addressing and resolving the concerns of students and staff in a timely and fair manner. Lorem ipsum dolor sit amet."
    },
    "anti-ragging": {
        title: "Anti-Ragging Cell",
        category: "Committees",
        content: "CEC maintains a zero-tolerance policy towards ragging. The cell ensures a safe, welcoming, and inclusive campus for all newcomers. Lorem ipsum dolor sit amet."
    },
    "internal-complaints": {
        title: "Internal Complaints Committee (ICC)",
        category: "Committees",
        content: "The ICC addresses issues related to workplace safety and gender sensitivity, ensuring a professional environment for all. Lorem ipsum dolor sit amet."
    },
    "iprc": {
        title: "Intellectual Property Rights Cells (IPRC)",
        category: "Committees",
        content: "IPRC encourages innovation and helps students and faculty navigate the process of patenting and protecting their intellectual property. Lorem ipsum dolor sit amet."
    },
    "research": {
        title: "Research & Development Cell",
        category: "Committees",
        content: "The R&D cell promotes a culture of inquiry, supporting interdisciplinary research projects and industry-academia collaborations. Lorem ipsum dolor sit amet."
    },
    "sc-st-cell": {
        title: "SC/ST/OBC Committee",
        category: "Committees",
        content: "Dedicated to the welfare and support of students from diverse backgrounds, ensuring equitable access to all institutional opportunities. Lorem ipsum dolor sit amet."
    },
    "iic": {
        title: "Institution Innovation Council (IIC)",
        category: "Committees",
        content: "Recognized by MHRD, the IIC drives the startup ecosystem on campus through workshops, hackathons, and mentorship. Lorem ipsum dolor sit amet."
    },
    "institution-industry-cell": {
        title: "Institution Industry Cell",
        category: "Committees",
        content: "Bridging the gap between academic learning and industrial requirements through internships and specialized training. Lorem ipsum dolor sit amet."
    },
    "iqac": {
        title: "Internal Quality Assurance Cell (IQAC)",
        category: "Committees",
        content: "IQAC focuses on continuous quality improvement in all academic and administrative tasks of the institution. Lorem ipsum dolor sit amet."
    },
    "campus-life": {
        title: "Campus Life",
        category: "Campus",
        content: "College of Engineering Chengannur offers a vibrant and enriching campus life that goes beyond academics. Our sprawling campus is home to diverse student communities, technical clubs, cultural events, and state-of-the-art recreational facilities. Students are encouraged to participate in various extracurricular activities, fostering leadership, teamwork, and personal growth."
    },

    // ACADEMICS
    "admission-2026": {
        title: "Admissions 2026",
        category: "Academics",
        content: `Admissions to the B.Tech programs for the academic year 2026-27 are currently open.

Admission through KEAM:
• Candidates who have qualified in KEAM can apply through the Centralized Allotment Process (CAP) conducted by CEE Kerala.

NRI Admission:
• Registration for the NRI quota is available. Prospective students can register for NRI seats directly.

Spot Admission:
• Spot admission details will be updated here after the KEAM allotment process is completed. 

[Register Now](https://docs.google.com/forms/d/e/1FAIpQLSfJUpcMKTLCnW3rsszP-okVQuDPmKRA4O_FYoH93SlBmMXT6w/viewform)`
    },
    "department": {
        title: "Departments",
        category: "Academics",
        content: "The college hosts five major departments: Computer Engineering, Electronics & Communication, Electrical & Electronics, Mechanical Engineering, and Applied Science & Humanities. Lorem ipsum dolor sit amet."
    },
    "apjaktu": {
        title: "APJAKTU",
        category: "Academics",
        content: "APJ Abdul Kalam Technological University, popularly known as KTU, is the premier technological university of Kerala established by the Government of Kerala to enhance the quality of engineering and technical education across the state. The university is dedicated to academic excellence, innovation, research, and industry-oriented learning, providing a modern curriculum that equips students with strong technical knowledge and practical skills. Affiliated colleges under KTU, including College of Engineering Chengannur, follow its academic regulations and standards, ensuring students receive a comprehensive education that prepares them for professional careers, higher studies, and contributions to technological advancement and society."
    },
    "aicte": {
        title: "AICTE",
        category: "Academics",
        content: "All India Council for Technical Education (AICTE) is the national-level statutory body and a council under the Government of India responsible for the planning, coordination, and development of technical education in the country. AICTE works to ensure quality standards in engineering, management, pharmacy, architecture, and other technical institutions by promoting innovation, research, skill development, and industry-oriented education. Through its regulations and initiatives, AICTE aims to enhance the overall standard of technical education and empower students with the knowledge and skills required to meet global technological and professional challenges."
    },

    // PROGRAMMES
    "btech": {
        title: "B.Tech Programmes",
        category: "Programmes",
        content: "Overview of the four-year undergraduate programs offered at CEC, including department-specific specializations. Lorem ipsum dolor sit amet."
    },
    "mca": {
        title: "Master of Computer Applications (MCA)",
        category: "Programmes",
        content: "Details about our highly sought-after postgraduate course in computer applications, focusing on advanced software development. Lorem ipsum dolor sit amet."
    },
    "doctoral": {
        title: "Doctoral Programmes (PhD)",
        category: "Programmes",
        content: "Information on research opportunities and PhD programs affiliated with KTU in various engineering disciplines. Lorem ipsum dolor sit amet."
    },

    // ORGANIZATIONS
    "ieee": {
        title: "IEEE Student Branch",
        category: "Organizations",
        content: "One of the most active student branches in the region, focusing on technological advancement and professional networking. Lorem ipsum dolor sit amet."
    },
    "foces": {
        title: "FOCES - CS Student Association",
        category: "Organizations",
        content: "The Forum of Computer Engineering Students is the heart of the CSE department, organizing tech fests and workshops. Lorem ipsum dolor sit amet."
    },
    "ncc": {
        title: "Naval NCC Unit",
        category: "Organizations",
        content: "Instilling discipline, patriotism, and leadership through rigorous naval training and community service. Lorem ipsum dolor sit amet."
    },
    "nss": {
        title: "National Service Scheme (NSS)",
        category: "Organizations",
        content: "Focusing on 'Not Me, But You', the NSS unit at CEC leads numerous social and environmental initiatives. Lorem ipsum dolor sit amet."
    },
    "prodecc": {
        title: "PRODECC - ECE Student Association",
        category: "Organizations",
        content: "The Professional Association of Electronics and Communication Students drives innovation in hardware and communication systems. Lorem ipsum dolor sit amet."
    },
    "excess": {
        title: "ExCESS - EEE Student Association",
        category: "Organizations",
        content: "The association for Electrical and Electronics Engineering students, promoting practical knowledge in power systems and renewable energy. Lorem ipsum dolor sit amet."
    },
    "surge": {
        title: "SURGE - ME Student Association",
        category: "Organizations",
        content: "Society of Undergraduate Research and Graduate Engineers, the association for Mechanical Engineering students. Lorem ipsum dolor sit amet."
    },
    "dept-computer-engineering": {
        title: "Department of Computer Engineering",
        category: "Academics",
        content: `The Department of Computer Engineering at College of Engineering Chengannur has been a pioneering force of excellence since its inception. The department offers comprehensive B.Tech and MCA courses designed to prepare students for the global IT landscape. 

Key Resources & Infrastructure:
• High-Performance Computing Lab
• Embedded Systems & IoT Laboratory
• Cloud Computing & Virtualization Centre
• Research focus in Machine Learning and Cyber Security`
    },
    "dept-electrical-engineering": {
        title: "Department of Electrical Engineering",
        category: "Academics",
        content: `The Department of Electrical Engineering prepares students to become leaders in power networks, renewable energy technologies, and industrial automation.

Key Resources & Infrastructure:
• Electrical Machines & Drives Lab
• Power Systems Simulation Laboratory
• Advanced Control Systems Centre
• Projects in Solar Energy Grid Integration`
    },
    "dept-electronics-engineering": {
        title: "Department of Electronics Engineering",
        category: "Academics",
        content: `The Department of Electronics Engineering is a recognized center of quality training in embedded hardware, VLSI design, and advanced communication networks.

Key Resources & Infrastructure:
• Advanced Microprocessors & VLSI Lab
• Digital Signal Processing Centre
• Communication & Networks Lab
• Research in Smart Hardware Prototyping`
    },
    "dept-general-engineering": {
        title: "Department of General Engineering",
        category: "Academics",
        content: `The Department of General Engineering provides critical foundational education in core engineering sciences, mechanics, graphics, and workshop practices to equip students with hands-on technical competencies.

Key Resources & Infrastructure:
• Engineering Workshop & Fab Shop
• Computer-Aided Drafting Lab
• Basic Engineering & Design Centre`
    },
    "dept-basic-science-language": {
        title: "Department of Basic Science & Language",
        category: "Academics",
        content: `The Department of Basic Science & Language builds a strong analytical and linguistic foundation through standard curricula in Engineering Mathematics, Applied Physics, Engineering Chemistry, and Professional Communication.

Key Resources & Infrastructure:
• Applied Physics Laboratory
• Engineering Chemistry Research Lab
• Language Lab & Professional Communication Centre`
    }
};
